import { getSocket } from '@/services/socket';

export default {
  namespaced: true,

  state: {
    connected: false,
    conversations: {},
    lastMessage: null,
    processedMessages: new Set(),
  },

  mutations: {
    SET_CONNECTED(state, status) {
      state.connected = status;
    },

    ADD_MESSAGE(state, message) {
      const { from } = message;

      if (!state.conversations[from]) {
        state.conversations[from] = [];
      }

      state.conversations[from].push({
        ...message,
        timestamp: Date.now(),
      });

      state.lastMessage = message;
    },

    ADD_SENT_MESSAGE(state, message) {
      const { to } = message;

      if (!state.conversations[to]) {
        state.conversations[to] = [];
      }

      state.conversations[to].push({
        ...message,
        status: 'sent',
        timestamp: Date.now(),
      });
    },

    MARK_AS_PROCESSED(state, messageId) {
      state.processedMessages.add(messageId);
    },

    CLEAR_MESSAGES(state) {
      state.conversations = {};
      state.lastMessage = null;
      state.processedMessages.clear();
    },
  },

  actions: {
    // 🔌 conexión
    socketConnected({ commit }) {
      commit('SET_CONNECTED', true);
    },

    socketDisconnected({ commit }) {
      commit('SET_CONNECTED', false);
    },

    // 📥 recibir mensajes
    receiveMessage({ commit, dispatch, state }, message) {
      const messageId = message.id || `${message.from}-${Date.now()}`;

      // 🔥 evitar duplicados
      if (state.processedMessages.has(messageId)) return;

      commit('MARK_AS_PROCESSED', messageId);
      commit('ADD_MESSAGE', message);

      dispatch('handleMessageAction', message);
    },

    // 📤 enviar mensajes
    sendMessage({ commit }, message) {
      const socket = getSocket();

      if (!socket) {
        this.openSnackbar({ message: 'Socket no disponible', type: 'error' });
        return;
      }

      socket.emit('send-message', message, (ack) => {
        if (!ack?.success) {
          console.error('Error enviando mensaje');
        }
      });

      commit('ADD_SENT_MESSAGE', message);
    },

    // 🎯 router de acciones
    handleMessageAction({ dispatch }, message) {
      const { action, payload } = message;

      const actionMap = {
        Notification: 'handleNotification',
        OPEN_FORM: 'handleOpenForm',
        CLOSE_APP: 'handleCloseApp',
      };

      const handler = actionMap[action];

      if (handler) {
        dispatch(handler, payload);
      } else {
        console.warn('⚠️ Acción no manejada:', action);
      }
    },

    // 🎯 handlers
    handleNotification(_, payload) {
      console.log('🔔 Notificación:', payload.text);
    },

    handleOpenForm(_, payload) {
      console.log('📄 Abrir formulario:', payload);
    },

    handleCloseApp(_, payload) {
      console.log('❌ Cerrar app:', payload);
    },
  },

  getters: {
    isConnected: (state) => state.connected,

    getConversation: (state) => (id) => state.conversations[id] || [],

    lastMessage: (state) => state.lastMessage,
  },
};
